import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let Blank = class Blank extends Vue {
    get src() {
        return this.data.cover.url;
    }
    mounted() {
        this.data.compMargin = '18';
        try {
            this.$el.parentElement.style.zIndex = '993';
        }
        catch { }
    }
    goToTop() {
        const container = document.getElementsByClassName(this.container)[0];
        if (container) {
            container.scrollTop = 0;
        }
        // if (container.scrollTo) {
        //   container.scrollTo({ top: 0, behavior: 'smooth' })
        // } else {
        //   container.scrollTop = 0
        // }
    }
};
tslib_1.__decorate([
    Prop()
], Blank.prototype, "data", void 0);
tslib_1.__decorate([
    Prop({ default: 'preview-box' })
], Blank.prototype, "container", void 0);
Blank = tslib_1.__decorate([
    Component({})
], Blank);
export default Blank;
